import { gql } from '@apollo/client';

export const GET_PRE_BILL_REVISION_UPLOAD_POLICY = gql`
  query GetPreBillRevisionUploadPolicy($businessScenarioCode: Long!) {
    getPreBillRevisionUploadPolicy(businessScenarioCode: $businessScenarioCode) {
      uploadAllowed
      blockedByInProgressTask
      inProgressTaskId
      blockedByWeeklyWindow
    }
  }
`;

export const GET_PRE_BILL_REVISION_TASKS = gql`
  query GetPreBillRevisionTasks($businessScenarioCode: Long!) {
    getPreBillRevisionTasks(businessScenarioCode: $businessScenarioCode) {
      id
      businessScenarioCode
      operatorName
      sourceFileName
      totalCount
      progressPercent
      resultFileS3Key
      resultFileName
      repushTaskKey
      status
      failureReason
      createdAt
      startedAt
      completedAt
    }
  }
`;

export const GET_PRE_BILL_REVISION_TASK_ERROR_DETAIL = gql`
  query GetPreBillRevisionTaskErrorDetail($taskId: Long!) {
    getPreBillRevisionTaskErrorDetail(taskId: $taskId)
  }
`;

export const ENQUEUE_PRE_BILL_REVISION_TASK_RESULT_REPORT = gql`
  mutation EnqueuePreBillRevisionTaskResultReport($preBillRevisionTaskId: Long!) {
    enqueuePreBillRevisionTaskResultReport(preBillRevisionTaskId: $preBillRevisionTaskId)
  }
`;

export const SUBMIT_PRE_BILL_REVISION_UPLOAD = gql`
  mutation SubmitPreBillRevisionUpload(
    $businessScenarioCode: Long!
    $fileBase64: String!
    $fileName: String!
  ) {
    submitPreBillRevisionUpload(
      businessScenarioCode: $businessScenarioCode
      fileBase64: $fileBase64
      fileName: $fileName
    )
  }
`;
